export default __webpack_public_path__ + "static/media/WelcomePage.98e1b7bb.png";